import { useState } from 'react';
import { IconButton, Icon, Tooltip, Popover, icon } from '@nula/core-ui';
import type { FormattingState } from '@/features/canvas/engine/hooks/use-formatting-state';
import styles from './text-style-group.module.css';

/**
 * Reusable bold / italic / underline / strikethrough toggle group, hosted
 * inside a popover triggered by a single Aa-style button. Used by every node
 * type that supports text formatting (Sticky, Shape, Text, Frame).
 */
export function TextStyleGroup({ state }: { state: FormattingState }) {
  const [open, setOpen] = useState(false);
  const content = (
    <div className={styles.styleGroup}>
      <Tooltip title="Bold" placement="top">
        <IconButton transparent aria-label="Bold" aria-pressed={state.bold} className={styles.btn} onClick={state.toggleBold}>
          <Icon name="format_bold" size={icon.md} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Italic" placement="top">
        <IconButton transparent aria-label="Italic" aria-pressed={state.italic} className={styles.btn} onClick={state.toggleItalic}>
          <Icon name="format_italic" size={icon.md} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Underline" placement="top">
        <IconButton transparent aria-label="Underline" aria-pressed={state.underline} className={styles.btn} onClick={state.toggleUnderline}>
          <Icon name="format_underlined" size={icon.md} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Strikethrough" placement="top">
        <IconButton transparent aria-label="Strikethrough" aria-pressed={state.strikethrough} className={styles.btn} onClick={state.toggleStrikethrough}>
          <Icon name="strikethrough_s" size={icon.md} />
        </IconButton>
      </Tooltip>
    </div>
  );

  return (
    <Popover content={content} trigger="click" placement="top" open={open} onOpenChange={setOpen}>
      <Tooltip title="Text style" placement="top" open={open ? false : undefined}>
        <IconButton
          transparent
          aria-label="Text style"
          aria-expanded={open}
          className={styles.btn}
        >
          <Icon name="format_bold" size={icon.md} />
        </IconButton>
      </Tooltip>
    </Popover>
  );
}
